"use client"

import { useEffect } from "react"

import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import { useEmitCustomAnalyticsEvent } from "~/hooks/tracking/useEmitCustomAnalyticsEvent"
import useLocale from "~/hooks/useLocale"
import type { TVariant } from "~/components/ui/ProductHeader/_data/types"
import { unlikelyProductToTrackingData } from "~/components/shared/AnalyticsEvents/utils/unlikely-product-to-tracking-data"
import { variantToTrackingData } from "~/components/shared/AnalyticsEvents/utils/variant-to-tracking-data"

type ClientViewItemProps = {
  product: UnlikelyProduct
  activeVariant: TVariant | null
}

export function ClientViewItem({ activeVariant, product }: ClientViewItemProps) {
  const { emitCustomEvent } = useEmitCustomAnalyticsEvent()
  const locale = useLocale()
  const payload = unlikelyProductToTrackingData({ product, locale })

  useEffect(() => {
    emitCustomEvent<"view_item">("view_item", {
      items: [{ ...payload, ...variantToTrackingData(activeVariant) }],
    })
  }, [activeVariant])

  return null
}
